module.exports = __webpack_public_path__ + "static/img/bg-highlights-3.3bf1eee1.png";